// @core/api/endpoints/analytics/generate_report.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GenerateReportRequest,
  ReportResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Generate report
 * Starts asynchronous generation of an analytics report. A Kafka event is published when the report is ready for download.
 */
export async function GenerateReport(
  data: GenerateReportRequest,
  options?: RequestOptions
): Promise<ReportResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/reports`;
  const requestOptions = options;
  return client.post<ReportResponse>(requestPath, data, requestOptions);
}
